<template>
    <footer class="site-footer">
        <div class="footer-inner">
            <div>
                <h2>Elkhorn Valley Family Medicine</h2>
                <address>304 East Douglas Street<br />O'Neill, NE 68763</address>
                <p><a href="tel:+14023364222">(402) 336-4222</a><br />Fax: (402) 336-4228</p>
                <router-link :to="{ path: '/', hash: '#visit-information' }">Hours &amp; directions</router-link>
            </div>
            <nav aria-label="Patient resources">
                <h2>Patient resources</h2>
                <ul>
                    <li><router-link to="/patient-forms">Patient forms</router-link></li>
                    <li><router-link to="/telemedicine">Telemedicine</router-link></li>
                    <li><router-link to="/office-policies">Office policies</router-link></li>
                </ul>
            </nav>
            <nav aria-label="Website information">
                <h2>Website information</h2>
                <ul>
                    <li><router-link to="/privacy-policy">Privacy policy</router-link></li>
                    <li><router-link to="/terms-of-use">Terms of use</router-link></li>
                </ul>
            </nav>
            <p class="copyright">Copyright &copy; 2013–{{currentYear}} Elkhorn Valley Family Medicine</p>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'Footer',
    data() {
        return {
            currentYear: new Date().getFullYear()
        }
    }
}
</script>

<style scoped>
.site-footer {
    background: var(--burgundy);
    color: #fff;
    text-align: left;
}
.footer-inner {
    display: grid;
    grid-template-columns: minmax(0, 1.5fr) repeat(2, minmax(0, 1fr));
    gap: 2rem;
    width: min(100% - 2.5rem, 72rem);
    margin: 0 auto;
    padding: 2.5rem 0 1.5rem;
    overflow-wrap: anywhere;
}
h2 {
    margin: 0 0 1rem;
    color: #fff;
    font-size: 1.1rem;
}
address {
    font-style: normal;
}
ul {
    margin: 0;
    padding: 0;
    list-style: none;
}
a {
    display: inline-block;
    min-height: 44px;
    padding: .45rem 0;
    color: #fff;
}
a:focus-visible {
    outline-color: #fff;
}
.copyright {
    grid-column: 1 / -1;
    margin: 0;
    padding-top: 1.5rem;
    border-top: 1px solid #ffffff40;
    font-size: .85rem;
}
@media screen and (max-width: 700px) {
    .footer-inner {
        grid-template-columns: 1fr;
    }
}
</style>
